import * as Yup from 'yup';
import TextInput from "./inputs/TextInput";
import { Button } from "antd";
import { postData, updateData } from "../helpers/api";
import { openNotification } from "../helpers/alerts";
import AddElementLayout from "./layouts/AddElementLayout";
import FieldArrayInput from "./inputs/FieldArray";

const AddProduct = (props) => {
    const { handleAfterAddingProduct, initialValue, isModalOpen, handleCancel } = props
    const handleSubmitForm = async (values, submitProps) => {
        try {
            if (values.id) {
                await updateData(`/products/${values.id}`, values)
                openNotification(`Le produit a été mis a jour avec succès`, 'success')

            } else {
                await postData("/products", values)
                openNotification(`Le produit a été ajouter avec succès`, 'success')
            }
            handleAfterAddingProduct()
            submitProps.resetForm()
        } catch (error) {
            if (error.status === 409) {
                openNotification(`Le produit existe déjà`, 'error')
                return;
            }
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }

    return (
        <AddElementLayout
            title={initialValue.id ? "Mis a jour le produit" : "Ajouter un produit"}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={{ ...initialValue, options: initialValue.options || [] }}
            validationSchema={Yup.object({
                name: Yup.string().required('required'),
                price: Yup.number().required('required'),
                stock: Yup.number().required('required'),
                options: Yup.array().of(
                    Yup.object({
                        size: Yup.string(),
                        color: Yup.string(),
                    })
                ).optional(),
            })}
            handleSubmitForm={handleSubmitForm}
        >
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px"
            }}>
                <TextInput
                    name="name"
                    placeholder="nom du produit"
                    size="large"
                />
                <TextInput
                    name="price"
                    placeholder="Prix du produit"
                    size="large"
                    type={"number"}
                />
                <TextInput
                    name="stock"
                    placeholder="stock"
                    size="large"
                    type={"number"}
                />
                <FieldArrayInput
                    name="options"
                    fieldToAdd={{ size: '', color: '' }}
                    renderInput={(index) => (
                        <div style={{ display: "flex", gap: "8px" }}>
                            <TextInput
                                name={`options[${index}].size`}
                                placeholder="Taille (size)"
                                size="large"
                            />
                            <TextInput
                                name={`options[${index}].color`}
                                placeholder="Couleur (color)"
                                size="large"
                            />
                        </div>
                    )}
                />
                <Button size='large' type="primary" htmlType="submit">
                    {initialValue.id ? "Mis a jour le produit" : "Ajouter le produit"}
                </Button>
            </div>
        </AddElementLayout>

    );
}

export default AddProduct;